import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React, { useContext, useEffect, useState } from "react";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../../constant";
import { useTranslation } from "react-i18next";
import AppContext from "../../../AppContext";
import { ReactSVG } from "react-svg";

const TeamList = () => {
  const { t } = useTranslation();
  const { authCtx, darkMode } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const boolColumn = (props) => {
    return (
      <div>
        {props.dataItem.active == true ? (
          <div className=" text-green-600 py-2">
            {t("masters.labels.active")}
          </div>
        ) : (
          <div className=" text-orange-600 py-2">
            {t("masters.labels.inactive")}
          </div>
        )}
      </div>
    );
  };
  const loadData = async () => {
    setLoading(true);
    const companyId = authCtx.profile.companyId;
    const res = await axios.get(
      `${BASE_URL}/api/TeamMaster?companyId=${companyId}`
    );
    if (res.status === 200) {
      setData(res.data);
      setFilteredData(res.data);
    }
    setLoading(false);
  };
  const onCloseClick = (e) => {
    navigate(`/settings`);
  };

  const onSearch = (e) => {
    setFilteredData(
      data.filter((s) =>
        s.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const onEditClick = (e) => {
    navigate(`/TeamForm/${e.dataItem.id}`);
  };

  useEffect(() => {
    loadData();
  }, []);

  const EditRow = (e) => {
    return (
      <td className="">
        <button
          className="flex flex-col justify-center items-center gap-1"
          onClick={() => onEditClick(e)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
            />
          </svg>
        </button>
      </td>
    );
  };

  useEffect(() => {
    // loadData();
  }, []);

  const navigate = useNavigate();
  const ActionCell = () => {
    return (
      <div className="flex gap-5 justify-center pr-10">
        <button type="button" onClick={onEditClick}>
          <ReactSVG
            src="EditIcon.svg"
            className="w-5 h-5 flex items-center justify-center "
            beforeInjection={(svg) => {
              svg.setAttribute(
                "style",
                `stroke: ${darkMode ? "white" : "black"}`
              );
            }}
          ></ReactSVG>
        </button>
      </div>
    );
  };

  const columns = [
    // {
    //   field: "code",
    //   title: t("masters.fields.code"),
    //   show: true,
    //   width: "auto",
    //   filterable: true,
    // },
    {
      field: "name",
      title: t("masters.fields.name"),
      show: true,
      width: "auto",
      filterable: true,
    },
    {
      field: "description",
      title: t("masters.fields.desc"),
      show: true,
      width: "auto",
      filterable: true,
    },
    {
      field: "active",
      title: t("masters.fields.active"),
      show: true,
      width: "auto",
      cell: boolColumn,
      filterable: true,
    },
    {
      field: "Action",
      title: t("masters.fields.action"),
      show: true,
      cell: EditRow,
      width: "auto",
      filterable: true,
    },
  ];

  const [stateColumns, setStateColumns] = React.useState(columns);

  return (
    <div className="flex flex-col text-white px-14 py-7 dark:bg-neutral-900 bg-white h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex text-sm font-medium gap-3 dark:text-white text-black items-center">
            <button type="button" onClick={() => onCloseClick()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.0"
                stroke="currentColor"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
            </button>
            <label className="text-xs lg:text-lg dark:text-white text-black">
              {t("masters.headerTexts.teamMaster")}
            </label>
          </div>
          <hr className="rotate-90 w-10 h-1 border-zinc-800"></hr>
          <div>
            <form>
              <div className="relative dark:bg-gray-900 bg-zinc-400 to-zinc-600 w-40 lg:w-80 h-9 rounded-lg border-zinc-800">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 text-neutral-700"
                    fill="none"
                    stroke={darkMode ? "white" : "black"}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  name="search"
                  className="block h-full pl-10 w-full text-xs lg:text-sm font-normal bg-inherit dark:text-white text-black dark:placeholder:text-white placeholder:text-black rounded-lg"
                  placeholder={t("masters.placeholders.teamSearch")}
                  onChange={onSearch}
                  required
                />
              </div>
            </form>
          </div>
        </div>
        <div className="flex dark:text-white text-black">
          <button
            type="button"
            onClick={() => navigate("/teamform/new")}
            className="flex text-xs lg:text-sm font-medium h-9 px-2 dark:bg-indigo-700 bg-[#00C6C2] rounded-4xl justify-center items-center gap-2 leading-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {t("button.addTeam")}
          </button>
        </div>
      </div>
      <div
        className={`h-5/6 mt-4 w-full mb-16 relative ${
          darkMode ? "darkGrid" : "lightGrid"
        }`}
      >
        {loading && <KendoLoadingPanel />}
        <Grid
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#181921",
            borderRadius: "15px",
            textAlign: "justify",
            overflowY: "auto",
            scrollbarGutter: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "auto",
          }}
          data={filteredData}
          onRowDoubleClick={onEditClick}
        >
          {stateColumns.map(
            (column, idx) =>
              column.show && (
                <GridColumn
                  key={idx}
                  field={column.field}
                  title={column.title}
                  filterable={column.filterable}
                  cell={column.cell}
                  width={column.width}
                  className="product-name"
                />
              )
          )}
        </Grid>
        <br />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default TeamList;
